import { useEffect } from "react";

import "style/ModalStyles.css";
const FindIdModal = (props: any) => {
  useEffect(() => {
    document.body.style.cssText = `
          position: fixed; 
          top: -${window.scrollY}px;
          overflow-y: scroll;
          width: 100%;`;
    return () => {
      const scrollY = document.body.style.top;
      document.body.style.cssText = "";
      window.scrollTo(0, parseInt(scrollY || "0", 10) * -1);
    };
  }, []);

  useEffect(() => {}, props.emailArr);

  return (
    <div className="modalBackground">
      <div className="modalContainer-edit-password">
        <br></br>
        <span id="font-SCD6">가입한 아이디(이메일)은 다음과 같습니다.</span>
        <br></br>
        <div className="termsBody" id="font-SCD3">
          <div
            className="display-center-margin-0"
            style={{ padding: "0 10px" }}
          >
            <div className="findModalLayout">
              {props.emailArr && props.emailArr.length > 0 ? (
                props.emailArr.map((email: any, index: any) => (
                  // <div className="" key={index}>
                  //   <input type="text" value={email}></input>
                  // </div>
                  <div>
                    <div className="input-form">
                      <input
                        className="input-form-w97p-40"
                        type="text"
                        value={email}
                        disabled={true}
                      ></input>
                    </div>
                  </div>
                ))
              ) : (
                <span id="font-SCD3">
                  해당 정보의 계정이 존재하지 않습니다.
                </span>
              )}
            </div>
          </div>
        </div>
        <div className="mfooter">
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <button
              className="terms-agree"
              onClick={() => props.setOpenModal(false)}
              id="font-SCD4"
            >
              확인
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FindIdModal;
